import { render, staticRenderFns } from "./PublicCatalogueAndMarketplace.vue?vue&type=template&id=6378f6ec"
import script from "./PublicCatalogueAndMarketplace.vue?vue&type=script&lang=js"
export * from "./PublicCatalogueAndMarketplace.vue?vue&type=script&lang=js"
import style0 from "./PublicCatalogueAndMarketplace.vue?vue&type=style&index=0&id=6378f6ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports